(function(){
var PRODUCTS = [{"id": "custom", "collection": "visor", "name": "Custom Visor Stickers", "tagline": "Your design. From scratch.", "price": "$55", "price_cents": 5500, "price_note": "", "badge": "BEST SELLER", "badge_cls": "grn", "variant_id": 42303018401895, "images": ["https://kggraphics.us/cdn/shop/files/IMG_2616.jpg?v=1774939067", "https://kggraphics.us/cdn/shop/files/IMG_1422.jpg?v=1783127942", "https://kggraphics.us/cdn/shop/files/IMG_8495.jpg?v=1774939067", "https://kggraphics.us/cdn/shop/files/IMG_0069.jpg?v=1783127918", "https://kggraphics.us/cdn/shop/files/IMG_0111.jpg?v=1774939067", "https://kggraphics.us/cdn/shop/files/IMG_2428.jpg?v=1774939067", "https://kggraphics.us/cdn/shop/files/IMG_3039.jpg?v=1774939067", "https://kggraphics.us/cdn/shop/files/IMG_3825.jpg?v=1774939067"], "description": "Your design, your name, your colors. Built from scratch. Set of 2 visor stickers.", "note": "At checkout, include all design details in the Special Instructions including colors, logos, text, and helmet model.", "variants": {"Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles", "Chrome"]}, "features": ["2 fully custom visor stickers", "Built entirely from your vision", "Any colors, logos, sponsors", "Fits all major helmet brands", "Premium weatherproof vinyl", "Made in the USA"], "handle": "custom-visor-sticker"}, {"id": "v1", "collection": "visor", "name": "Visor Stickers V1", "tagline": "The original. Bold. Sharp.", "price": "$30", "price_cents": 3000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 42304626458727, "images": ["https://kggraphics.us/cdn/shop/files/Red_Blank.jpg?v=1783117213", "https://kggraphics.us/cdn/shop/files/Blue_Blank.jpg?v=1783117213", "https://kggraphics.us/cdn/shop/files/Green_Blank.jpg?v=1783117213", "https://kggraphics.us/cdn/shop/files/Orange_Blank.jpg?v=1783117213", "https://kggraphics.us/cdn/shop/files/Pink_Blank.jpg?v=1783117212", "https://kggraphics.us/cdn/shop/files/White_Blank.jpg?v=1783117212"], "description": "The original KG Graphics design. Aggressive lines, clean finish. Set of 2 visor stickers.", "note": "For the custom color option, include your color request in the Special Instructions at checkout.", "variants": {"Color": ["Red", "Blue", "Green", "Orange", "Pink", "White", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "features": ["Pair of 2 stickers included", "7 colorways + custom", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Glossy, Holographic, or Chrome finish", "Made in the USA"], "handle": "style-1"}, {"id": "v2", "collection": "visor", "name": "Visor Stickers V2", "tagline": "Aggressive lines. Maximum presence.", "price": "$30", "price_cents": 3000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 42304646152295, "images": ["https://cdn.shopify.com/s/files/1/0652/3220/7975/files/RedBlank.jpg?v=1783117575", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/BlueBlank.jpg?v=1783117575", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/GreenBlank.jpg?v=1783117575", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/OrangeBlank.jpg?v=1783117576", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/PinkBlank.jpg?v=1783117575", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/WhiteBlank.jpg?v=1783117575"], "description": "Bolder geometry, race-proven profile. Step up from the original. Set of 2 visor stickers.", "note": "For custom color options, include your request in the Special Instructions at checkout.", "variants": {"Color": ["Red", "Blue", "Green", "Orange", "Pink", "White", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "features": ["Pair of 2 stickers included", "Bold diagonal design", "Multiple colorways", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Made in the USA"], "handle": "style-2-visor-sticker"}, {"id": "v3", "collection": "visor", "name": "Visor Stickers V3", "tagline": "Latest evolution. Refined detail.", "price": "$30", "price_cents": 3000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 42304665550951, "images": ["https://cdn.shopify.com/s/files/1/0652/3220/7975/files/Red_Blank_0f527a8d-a8ad-435d-9a9b-08f2287eb783.jpg?v=1783117757", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/BlueBlank_66398380-4411-4b53-811a-b5be861e6596.jpg?v=1783117726", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/GreenBlank_91306598-dd8a-4b3d-aa4e-1085d00167a3.jpg?v=1783117726", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/OrangeBlank_56bcc180-8ef9-4e0f-abcb-45d80a74c8dd.jpg?v=1783117726", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/PinkBlank_5c7fc3fa-a22b-4e1d-852b-7cfe9ed75877.jpg?v=1783117726", "https://cdn.shopify.com/s/files/1/0652/3220/7975/files/WhiteBlank_07cc12be-1143-46ae-a2cd-d28f96aae989.jpg?v=1783117726"], "description": "Our newest, most refined design. Layered detail that stands out. Set of 2 visor stickers.", "note": "For custom color options, include your request in the Special Instructions at checkout.", "variants": {"Color": ["Red", "Blue", "Green", "Orange", "Pink", "White", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "features": ["Pair of 2 stickers included", "Triple-stripe layered design", "Multiple colorways", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Ships in 2-3 business days"], "handle": "style-3-visor-sticker"}, {"id": "v4", "handle": "visor-stickers-v4", "collection": "visor", "name": "Visor Stickers V4", "price": "$30", "price_cents": 3000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 44165141758055, "images": ["https://kggraphics.us/cdn/shop/files/Red_5dddc158-5a41-4b73-9abd-e6071c97716e.jpg?v=1783199059&width=3840", "https://kggraphics.us/cdn/shop/files/Blue_d1f3ecc3-8068-4b47-9231-d163f7cd238c.jpg?v=1783199059&width=3840", "https://kggraphics.us/cdn/shop/files/Green_c7f984c0-9b79-4293-953a-01d04527c503.jpg?v=1783199059&width=3840", "https://kggraphics.us/cdn/shop/files/Orange_70cf8cdc-6736-43b5-a399-b0f1996776aa.jpg?v=1783199059&width=3840", "https://kggraphics.us/cdn/shop/files/Pink_7d06b9da-ae43-46f1-bb6a-0126eab5dabe.jpg?v=1783199059&width=3840", "https://kggraphics.us/cdn/shop/files/White_0900a960-8641-4dc1-a96b-064596a9ea2b.jpg?v=1783199059&width=3840"], "variants": {"Color": ["Red", "Blue", "Green", "Orange", "Pink", "White", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "description": "Sharp, angular design built for the track. Bold presence, clean lines. Set of 2 visor stickers.", "tagline": "Sharp angles. Race-ready style.", "note": "For the custom color option, include your color request in the Special Instructions at checkout.", "features": ["Pair of 2 stickers included", "7 colorways + custom", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Glossy, Holographic, or Chrome finish", "Made in the USA"]}, {"id": "v5", "handle": "visor-stickers-v5", "collection": "visor", "name": "Visor Stickers V5", "price": "$30", "price_cents": 3000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 44165199757415, "images": ["https://kggraphics.us/cdn/shop/files/Red_6611064d-1a49-4444-979c-0c04504a1fb4.jpg?v=1783204037&width=3840", "https://kggraphics.us/cdn/shop/files/Blue_9c6b11e6-6001-4553-84c7-868d73dad8f0.jpg?v=1783204036&width=3840", "https://kggraphics.us/cdn/shop/files/Green_c0e261e3-ef89-4e56-b070-3c63aae37c7c.jpg?v=1783204037&width=3840", "https://kggraphics.us/cdn/shop/files/Orange_796af808-7af9-4009-af10-bebb4fc0bc56.jpg?v=1783204037&width=3840", "https://kggraphics.us/cdn/shop/files/Pink_ca0f70f3-5314-4127-ab9f-d0f3126804b4.jpg?v=1783204037&width=3840", "https://kggraphics.us/cdn/shop/files/White_b15509ab-9793-4de9-8f18-ee9b98b7c5ba.jpg?v=1783210552&width=3840"], "variants": {"Color": ["Red", "Blue", "Green", "Orange", "Pink", "White", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "description": "Our latest design. Sleek, aggressive, race-ready. Set of 2 visor stickers.", "tagline": "Our latest design. Sleek and aggressive.", "note": "For the custom color option, include your color request in the Special Instructions at checkout.", "features": ["Pair of 2 stickers included", "7 colorways + custom", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Glossy, Holographic, or Chrome finish", "Made in the USA"]}, {"id": "formula", "handle": "formula-series", "collection": "visor", "name": "Formula Series", "price": "$35", "price_cents": 3500, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 44165305368679, "images": ["https://kggraphics.us/cdn/shop/files/Mercedes.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Ferrari.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/McLaren.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/RedBull.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Alpine.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/RB.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Haas.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Williams.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Audi.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/AstonMartin.jpg?v=1783449377", "https://kggraphics.us/cdn/shop/files/Cadillac.jpg?v=1783449377"], "variants": {"Team": ["Mercedes", "Red Bull", "Ferrari", "McLaren", "RB", "Alpine", "Audi", "Haas", "Williams", "Cadillac", "Aston Martin"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "description": "Accurately replicates iconic F1 team visor stickers. Set of 2 visor stickers.", "tagline": "Iconic F1 team liveries for your visor.", "note": "Select your F1 team, helmet type and finish. Pair of two stickers included.", "features": ["Pair of 2 stickers included", "Multiple team/brand options", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Glossy, Holographic, or Chrome finish", "Made in the USA"]}, {"id": "kart", "handle": "kart-visor-stickers", "collection": "visor", "name": "Kart Series", "price": "$35", "price_cents": 3500, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 44133778620519, "images": ["https://kggraphics.us/cdn/shop/files/TonyKart.jpg?v=1783131427", "https://kggraphics.us/cdn/shop/files/KartRepublic.jpg?v=1783131427", "https://kggraphics.us/cdn/shop/files/Birel_Art.jpg?v=1783453291", "https://kggraphics.us/cdn/shop/files/CRG.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/Praga.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/EOS.jpg?v=1783131427", "https://kggraphics.us/cdn/shop/files/Maranello.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/Pantano.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/Factory.jpg?v=1783453289", "https://kggraphics.us/cdn/shop/files/Compkart.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/Croc.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/EKS.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/Tillotson.jpg?v=1783453292", "https://kggraphics.us/cdn/shop/files/K1_Speed.jpg?v=1783453291"], "variants": {"Kart": ["Tony Kart", "Kart Republic", "Birel Art", "CRG", "Praga", "EOS", "Maranello", "Pantano", "Factory", "Compkart", "Croc Promotion", "EKS", "Tillotson", "K1 Speed"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Glossy", "Holographic", "Chrome", "Glossy + Silver Sparkles", "Holographic + Silver Sparkles", "Chrome + Silver Sparkles", "Glossy + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Chrome + Rainbow Sparkles"]}, "description": "Inspired by iconic karting liveries. Set of 2 visor stickers.", "tagline": "Iconic karting liveries for your visor.", "note": "Select your kart brand, helmet type and finish. Pair of two stickers included.", "features": ["Pair of 2 stickers included", "Multiple team/brand options", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Glossy, Holographic, or Chrome finish", "Made in the USA"]}, {"id": "driver", "collection": "driver", "name": "Driver Stickers", "tagline": "Put your name on the kart.", "price": "$10", "price_cents": 1000, "price_note": "", "badge": "BEST SELLER", "badge_cls": "grn", "variant_id": 42265601933415, "images": ["https://kggraphics.us/cdn/shop/files/All.jpg?v=1783123271", "https://kggraphics.us/cdn/shop/files/V1.jpg?v=1783122537", "https://kggraphics.us/cdn/shop/files/V2.jpg?v=1783122539", "https://kggraphics.us/cdn/shop/files/V3.jpg?v=1783122540", "https://kggraphics.us/cdn/shop/files/V4.jpg?v=1783122546", "https://kggraphics.us/cdn/shop/files/Name_Stickers.png?v=1775006241"], "description": "Custom name stickers for your helmet and kart fairing.", "note": "Include your name, number, colors, and design requests in the Special Instructions at checkout.", "variants": {"Style": ["V1", "V2", "V3", "V4"], "Finish": ["Chrome", "Chrome + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Glossy + Rainbow Sparkles", "Chrome + Silver Sparkles", "Holographic + Silver Sparkles", "Glossy + Silver Sparkles", "Holographic", "Glossy"], "Color": ["Black", "White", "Custom (Please Specify)"]}, "features": ["Fully customized with your name and number", "4 style options", "Fits helmets and kart fairings", "Premium weatherproof vinyl", "Chrome, Holographic, or Glossy finish", "Made in the USA"], "handle": "name-stickers-v1"}, {"id": "numbers", "collection": "numbers", "name": "Kart Numbers", "tagline": "Bold. High-contrast. Race-ready.", "price": "$3", "price_cents": 300, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 42304944144487, "images": ["https://kggraphics.us/cdn/shop/files/Yellow_a14dd4d6-5011-4a0e-b01a-39c1883dcb50.jpg?v=1783121008", "https://kggraphics.us/cdn/shop/files/White_9055a23d-d5e2-4582-ab08-3dd4e006cc06.jpg?v=1783121008"], "description": "High-contrast race number stickers. Priced per number.", "note": "Specify your number and preferences in the Special Instructions at checkout.", "variants": {"Number": ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], "Finish": ["Chrome", "Chrome + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Glossy + Rainbow Sparkles", "Chrome + Silver Sparkles", "Holographic + Silver Sparkles", "Glossy + Silver Sparkles", "Holographic", "Glossy"], "Color": ["Yellow", "White", "Custom (Please Specify)"]}, "features": ["Any number 0-9", "Priced per sticker", "High-contrast bold design", "Chrome, Holographic, or Glossy finish", "Weatherproof vinyl", "Made in the USA"], "handle": "kart-numbers"}, {"id": "flag", "collection": "visor", "name": "Patriotic Series", "tagline": "Race with pride.", "price": "$40", "price_cents": 4000, "price_note": "", "badge": "", "badge_cls": "", "variant_id": 42369287815271, "images": ["https://kggraphics.us/cdn/shop/files/BlackBlank.jpg?v=1783118320", "https://kggraphics.us/cdn/shop/files/WhiteBlank_7fed48c2-c673-4bf6-8124-aa44db340ca5.jpg?v=1783118320"], "description": "Race with pride. Stars, stripes, premium vinyl. Set of 2 visor stickers.", "note": "For custom color options, include your preference in the Special Instructions at checkout.", "variants": {"Color": ["Black", "White", "Red", "Blue", "Green", "Orange", "Pink", "Yellow", "Custom (Please Specify)"], "Helmet Type": ["Arai SK6", "Arai GP7", "Arai CK6", "Bell KC7", "Bell RS7", "Stilo ST5", "Schuberth SP1", "Zamp RZ", "Other"], "Finish": ["Chrome", "Chrome + Rainbow Sparkles", "Holographic + Rainbow Sparkles", "Glossy + Rainbow Sparkles", "Chrome + Silver Sparkles", "Holographic + Silver Sparkles", "Glossy + Silver Sparkles", "Holographic", "Glossy"]}, "features": ["Pair of 2 visor stickers", "9 color options plus custom", "Fits Arai, Bell, Stilo, Schuberth, Zamp and more", "Premium weatherproof vinyl", "Chrome, Holographic, or Glossy finish", "Made in the USA"], "handle": "driver-visor-stickers-v1"}];
var PM = {};
PRODUCTS.forEach(function(p){ PM[p.id]=p; });

// ── PAGES ──
var PH      = document.getElementById('ph');
var PP      = document.getElementById('pp');
var PC      = document.getElementById('pc-page');
var PCART   = document.getElementById('pc-cart');
var PCON    = document.getElementById('pc-contact');
var PPRIV   = document.getElementById('pc-privacy');
var nav     = document.getElementById('nav');
var burger  = document.getElementById('burger');
var mmenu   = document.getElementById('mmenu');

// ── CART STATE ──
var cart = [];
function saveCart(){ try{ localStorage.setItem('kg_cart', JSON.stringify(cart)); var instrEl=document.getElementById('cart-instr'); if(instrEl) localStorage.setItem('kg_instr',instrEl.value); }catch(e){} }
var savedInstr='';
function loadCart(){ try{ var s=localStorage.getItem('kg_cart'); if(s) cart=JSON.parse(s); savedInstr=localStorage.getItem('kg_instr')||''; }catch(e){} updateCartBadge(); }
loadCart();

function updateCartBadge(){
  var total = cart.reduce(function(s,i){return s+i.qty;}, 0);
  var badge = document.getElementById('cart-badge');
  if(badge){ badge.textContent = total; badge.classList.toggle('show', total > 0); }
}

function showToast(msg){
  var t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 2000);
}


// ── VARIANT LOOKUP ──
// Cache of variant data per product handle
var variantCache = {};

function fetchVariants(handle, callback){
  if(variantCache[handle]){ callback(variantCache[handle]); return; }
  // Fetch all variant pages (Shopify returns max 250 per page)
  var allVariants = [];
  function fetchPage(page){
    fetch('https://kggraphics.us/products/'+handle+'.json?limit=250&page='+page)
      .then(function(r){ return r.json(); })
      .then(function(data){
        var variants = data.product ? data.product.variants : [];
        allVariants = allVariants.concat(variants);
        if(variants.length === 250){
          // More pages may exist
          fetchPage(page + 1);
        } else {
          variantCache[handle] = allVariants;
          callback(allVariants);
        }
      })
      .catch(function(){ callback(allVariants.length ? allVariants : null); });
  }
  fetchPage(1);
}

function findVariantId(variants, selectedOpts){
  if(!variants || !variants.length) return null;
  var selectedValues = Object.values(selectedOpts).filter(Boolean);
  // Find variant where ALL selected option values match
  var match = variants.find(function(v){
    var variantOpts = [v.option1, v.option2, v.option3].filter(Boolean);
    return selectedValues.every(function(sel){
      return variantOpts.indexOf(sel) > -1;
    });
  });
  return match ? match.id : null;
}



// ── FINISH-BASED DYNAMIC PRICING ──
function getFinishPrice(baseCents, finish, productId) {
  if (!finish) return baseCents;
  var f = finish.toLowerCase();
  // Numbers has different increments: +$1 holo/chrome, +$2 sparkles
  if (productId === 'numbers') {
    if (f.indexOf('sparkle') > -1) return baseCents + 200;
    if (f.indexOf('holographic') > -1 || f.indexOf('chrome') > -1) return baseCents + 100;
    return baseCents;
  }
  // All other products: +$5 holo/chrome, +$10 sparkles
  if (f.indexOf('sparkle') > -1) return baseCents + 1000;
  if (f.indexOf('holographic') > -1 || f.indexOf('chrome') > -1) return baseCents + 500;
  return baseCents;
}

function addToCart(product, opts, resolvedVariantId){
  var variantId = resolvedVariantId || product.variant_id;
  var key = product.id + JSON.stringify(opts);
  var existing = cart.find(function(i){ return i.key===key; });
  if(existing){ existing.qty++; }
  else{ var finishVal = opts['Finish'] || '';
  var dynCents = getFinishPrice(product.price_cents, finishVal, product.id);
  var dynPrice = '$'+(dynCents/100).toFixed(2).replace('.00','');
  // Always use a valid variant_id — fall back to product default if lookup failed
  var safeVariantId = variantId || product.variant_id;
  cart.push({key:key,id:product.id,name:product.name,price:dynPrice,price_cents:dynCents,price_note:product.price_note||'',image:product.images[0],opts:Object.assign({},opts),qty:1,variant_id:safeVariantId}); }
  saveCart();
  updateCartBadge();
  var panel=document.getElementById('cart-panel');
  var cpName=document.getElementById('cp-name');
  var cpBar=document.getElementById('cp-bar');
  cpName.textContent=product.name;
  // Reset animations
  panel.classList.remove('slide-in','slide-out');
  cpBar.style.animation='none'; void cpBar.offsetWidth; cpBar.style.animation='';
  void panel.offsetWidth;
  panel.classList.add('slide-in');
  // After panel is in, prepare and slide in cart page simultaneously with panel exit
  setTimeout(function(){
    // Render cart while panel is still showing
    renderCart();
    hideAll();
    PCART.style.display='block';
    injectFooter(PCART);
    document.title='Cart - KG Graphics';
    window.scrollTo({top:0,behavior:'instant'});
    document.getElementById('pc-cart-hash') && history.pushState(null,null,'#pc-cart');
    // Start cart sliding up from bottom
    // Slide panel back up
    panel.classList.add('slide-out');
    setTimeout(function(){
      panel.classList.remove('slide-in','slide-out');
    }, 420);
  }, 750);
}

// ── HIDE ALL ──
function hideAll(){
  PH.style.display='none';
  PP.style.display='none';
  PC.style.display='none';
  PCART.style.display='none';
  if(PCON) PCON.style.display='none';
  if(PPRIV) PPRIV.style.display='none';
}

// ── NAV ──
window.addEventListener('scroll',function(){ nav.classList.toggle('up',window.scrollY>20); },{passive:true});
function openM(){ burger.classList.add('on'); mmenu.classList.add('on'); burger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
function closeM(){ burger.classList.remove('on'); mmenu.classList.remove('on'); burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
burger.addEventListener('click',function(){ burger.classList.contains('on')?closeM():openM(); });
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeM(); });

// ── GO HOME ──
var prevPage = null;
function goHome(sec){
  window.goHome=goHome;
  hideAll(); PH.style.display='block';
  prevPage = 'home';
  document.title='KG Graphics - Racing Stickers and Visors';
  window.scrollTo({top:0,behavior:'instant'});
  if(sec){
    requestAnimationFrame(function(){
      var el=document.getElementById(sec);
      if(el) window.scrollTo({top:el.getBoundingClientRect().top+window.scrollY-nav.offsetHeight-12,behavior:'smooth'});
    });
  }
  startReveal(); closeM();
}

// ── GO ALL PRODUCTS ──
function goAllProducts(){
  // Temporarily tag all products as 'all' collection, call goCollection, then restore
  var orig = PRODUCTS.map(function(p){ return p.collection; });
  PRODUCTS.forEach(function(p){ p.collection = 'all'; });
  COLL_META['all'] = {title:'All Products', sub:'The full KG Graphics lineup.'};
  goCollection('all');
  // Restore original collections
  PRODUCTS.forEach(function(p,i){ p.collection = orig[i]; });
}
window.goAllProducts = goAllProducts;

// ── GO COLLECTION ──
var COLL_META = {
  visor:  {title:'Visor Stickers',  sub:'Custom and pre-made visor stickers for all major karting helmets.'},
  driver: {title:'Driver Stickers', sub:'Custom name stickers for your helmet and kart fairing.'},
  numbers:{title:'Kart Numbers',    sub:'High-contrast race number stickers in any finish.'},
};

function goCollection(coll){
  closeM();
  var prods = PRODUCTS.filter(function(p){return p.collection===coll;});
  var meta  = COLL_META[coll] || {title:coll,sub:''};
  document.getElementById('coll-title').textContent = meta.title;
  document.getElementById('coll-sub').textContent   = meta.sub;
  var grid = document.getElementById('coll-grid');
  grid.innerHTML = '';
  prods.forEach(function(p){
    var btn = document.createElement('button');
    btn.className = 'pc rv';
    btn.setAttribute('data-product-dyn', p.id);
    var bc = p.badge_cls ? ' '+p.badge_cls : '';
    var hasBadge = p.id === 'custom';
    var badgeHtml = hasBadge ? '<div class="pc-badge grn">BEST SELLER</div>' : '';
    btn.innerHTML = '<div class="pc-img"><img src="'+p.images[0]+'" alt="'+p.name+'" loading="lazy">'+badgeHtml+'</div><div class="pc-body"><div class="pc-name">'+p.name+'</div><div class="pc-desc">'+p.description.substring(0,80)+'...</div><div class="pc-foot"><div class="pc-price">'+p.price+(p.price_note?'<small>'+p.price_note+'</small>':'')+' <span class="pc-sale">10% OFF</span></div><div class="pc-arr">&#x2197;</div></div></div>';
    btn.addEventListener('click',function(){ goProduct(p.id,'coll:'+coll); });
    grid.appendChild(btn);
  });
  hideAll(); PC.style.display='block';
  injectFooter(PC);
  prevPage = 'coll:'+coll;
  document.title = meta.title+' - KG Graphics';
  window.scrollTo({top:0,behavior:'instant'});
  startReveal();
  document.getElementById('coll-back').onclick = function(){ goHome(null); };
}

window.goCollection = goCollection;
// ── GO PRODUCT ──
window.goHome = goHome;
function goProduct(id, from){
  var p=PM[id]; if(!p) return;
  prevPage = from || 'home';
  document.title = p.name+' - KG Graphics';
  var bdg=document.getElementById('pd-bdg');
  bdg.textContent=p.badge;
  bdg.className='pd-bdg'+(p.badge_cls?' '+p.badge_cls:'');
  document.getElementById('pd-name').textContent=p.name;
  document.getElementById('pd-tag').textContent=p.tagline;
  document.getElementById('pd-pr').textContent=p.price;
  document.getElementById('pd-pn').textContent=p.price_note||'';
  document.getElementById('pd-desc').textContent=p.description;
  document.getElementById('pd-note').innerHTML='<strong>Note:</strong> '+p.note;
  var fl=document.getElementById('pd-feats'); fl.innerHTML='';
  p.features.forEach(function(f){ var li=document.createElement('li'); li.textContent=f; fl.appendChild(li); });
  var tw=document.getElementById('pd-thumbs'); tw.innerHTML='';
  tw.className='pd-grid';
  setTimeout(initMobileSwiper, 0);
  p.images.forEach(function(src,i){
    var img=document.createElement('img');
    img.src=src; img.alt=p.name; img.loading= i===0 ? 'eager' : 'lazy';
    tw.appendChild(img);
  });
  // Variants
  var vgs=document.getElementById('pd-vgs'); vgs.innerHTML='';
  var selectedOpts={};
  Object.keys(p.variants).forEach(function(label){
    var opts=p.variants[label];
    var vg=document.createElement('div'); vg.className='pd-vg';
    var lbl=document.createElement('span'); lbl.className='pd-vl'; lbl.textContent=label+':';
    var vw=document.createElement('div'); vw.className='pd-vars';
    selectedOpts[label] = opts[0];
    opts.forEach(function(opt,i){
      {
        var b=document.createElement('button'); b.className='pv'+(i===0?' on':''); b.textContent=opt;
        b.addEventListener('click',function(){
          vw.querySelectorAll('.pv').forEach(function(x){x.classList.remove('on');});
          b.classList.add('on'); selectedOpts[label]=opt;
          // Update price display if Finish changed
          if(label==='Finish'){
            var newCents=getFinishPrice(p.price_cents,opt,p.id);
            var newPrice='$'+(newCents/100).toFixed(2).replace('.00','');
            document.getElementById('pd-pr').textContent=newPrice;
          }
        });
        vw.appendChild(b);
      }
    });
    vg.appendChild(lbl); vg.appendChild(vw); vgs.appendChild(vg);
  });
  // Add to cart
  document.getElementById('pd-add').onclick=function(){
    var opts = Object.assign({},selectedOpts);
    if(p.handle){
      fetchVariants(p.handle, function(variants){
        var varId = findVariantId(variants, opts);
        addToCart(p, opts, varId);
      });
    } else {
      addToCart(p, opts, null);
    }
  };
  // Also like
  var ag=document.getElementById('also-grid'); ag.innerHTML='';
  PRODUCTS.filter(function(q){return q.id!==id;}).slice(0,4).forEach(function(q){
    var btn=document.createElement('button'); btn.className='pc';
    btn.innerHTML='<div class="pc-img"><img src="'+q.images[0]+'" alt="'+q.name+'" loading="lazy"></div><div class="pc-body"><div class="pc-name">'+q.name+'</div><div class="pc-foot"><div class="pc-price">'+q.price+'</div><div class="pc-arr">&#x2197;</div></div></div>';
    btn.addEventListener('click',function(){ goProduct(q.id,prevPage); window.scrollTo({top:0,behavior:'instant'}); });
    ag.appendChild(btn);
  });
  // Back
  document.getElementById('pd-back').onclick=function(){
    if(prevPage && prevPage.startsWith('coll:')){ goCollection(prevPage.replace('coll:','')); }
    else{ goHome(null); }
  };
  hideAll(); PP.style.display='block';
  injectFooter(PP);
  window.scrollTo({top:0,behavior:'instant'});
  closeM();
}

window.goProduct = goProduct;
// ── GO CART ──
function goCart(){
  closeM();
  renderCart();
  hideAll();
  PCART.style.display='block';
  injectFooter(PCART);
  document.title='Cart - KG Graphics';
  window.scrollTo({top:0,behavior:'instant'});
  document.getElementById('cart-back').onclick=function(){ goHome(null); setTimeout(function(){ var el=document.getElementById('products'); if(el) el.scrollIntoView({behavior:'smooth'}); },400); };
}

window.goCart = goCart;
// ── RENDER CART ──
function renderCart(){
  var body=document.getElementById('cart-body');
  if(cart.length===0){
    body.innerHTML='<div class="cart-empty"><p>Your cart is empty.</p><button class="btn-f shop-products-btn" style="margin:0 auto;">Shop Now</button></div>';
    setTimeout(function(){
      var btn=document.querySelector('.shop-products-btn');
      if(btn) btn.addEventListener('click',function(){ goHome(null); setTimeout(function(){ document.getElementById('products').scrollIntoView({behavior:'smooth'}); },400); });
    },0);
    return;
  }
  var html='';
  cart.forEach(function(item,idx){
    var optsText=Object.entries(item.opts).filter(function(e){return e[1];}).map(function(e){return e[0]+': '+e[1];}).join(' | ');
    html+='<div class="cart-item">';
    html+='<div class="cart-item-img"><img src="'+item.image+'" alt="'+item.name+'" loading="lazy"></div>';
    html+='<div class="cart-item-info">';
    html+='<div class="cart-item-name">'+item.name+'</div>';
    if(optsText) html+='<div class="cart-item-opts">'+optsText+'</div>';
    html+='<div class="cart-item-row">';
    html+='<div class="cart-qty">';
    html+='<button onclick="changeQty('+idx+',-1)" aria-label="Remove one">&#x2212;</button>';
    html+='<span>'+item.qty+'</span>';
    html+='<button onclick="changeQty('+idx+',1)" aria-label="Add one">+</button>';
    html+='</div>';
    var priceNote=item.price_note?(' <small style="font-size:11px;color:#9280A8;">/'+item.price_note+'</small>'):'';
    html+='<div class="cart-item-price">'+item.price+priceNote+'</div>';
    html+='</div>';
    html+='<button class="cart-remove" onclick="removeItem('+idx+')">Remove</button>';
    html+='</div></div>';
  });

  var subtotal=cart.reduce(function(s,i){return s+Number(i.price_cents)*i.qty;},0);
  var disc=Math.round(subtotal*0.1);
  var total=subtotal-disc;
  var fmt=function(c){return '$'+(c/100).toFixed(2);};

  var cartItems=cart.map(function(i){return i.variant_id+':'+i.qty;}).join(',');
  var notes=cart.map(function(i){
    var o=Object.entries(i.opts).filter(function(e){return e[1];}).map(function(e){return e[0]+': '+e[1];}).join(', ');
    return i.name+(o?' ('+o+')':'');
  }).join('; ');
  var instrEl=document.getElementById('cart-instr');
  var instrText=instrEl?instrEl.value.trim():'';
  var fullNotes=(notes&&instrText)?notes+' | Instructions: '+instrText:(instrText?'Instructions: '+instrText:notes);
  var checkoutUrl='https://kggraphics.us/cart/'+cartItems+(fullNotes?'?note='+encodeURIComponent(fullNotes):'');

  // Complete the look upsell
  var hasVisor = cart.some(function(i){ return i.id !== 'driver' && i.id !== 'numbers'; });
  var hasDriver = cart.some(function(i){ return i.id === 'driver'; });
  if(hasVisor && !hasDriver){
    html+='<div class="cart-upsell">';
    html+='<div class="cart-upsell-eye">Complete the Look</div>';
    html+='<div class="cart-upsell-body">';
    html+='<div class="cart-upsell-text">Add Driver Stickers and stand out from every angle — helmet <em>and</em> kart.</div>';
    html+='<button class="cart-upsell-btn" onclick="goProduct(\'driver\',\'cart\')">Shop Driver Stickers &#x2192;</button>';
    html+='</div>';
    html+='</div>';
  }

  // Special instructions
  html+='<div class="cart-instructions">';
  html+='<label class="cart-instr-label" for="cart-instr">Special Instructions</label>';
  html+='<textarea id="cart-instr" class="cart-instr-input" placeholder="Add any special requests, custom color details, design notes, or other instructions for your order..."></textarea>';
  html+='</div>';
  html+='<div class="cart-summary">';
  html+='<div class="cart-row"><span>Subtotal</span><span>'+fmt(subtotal)+'</span></div>';
  html+='<div class="cart-row" style="color:var(--grn);font-weight:600;"><span>10% Discount</span><span>-'+fmt(disc)+'</span></div>';
  html+='<div class="cart-total-row"><div class="cart-total-label">Total</div><div class="cart-total-price">'+fmt(total)+'</div></div>';
  html+='<p class="cart-note">Custom options are added to your order note. Orders dispatched within 2-5 business days.</p>';
  // Store base checkout URL (without instructions) for dynamic button
  html+='<a href="#" class="cart-checkout" id="cart-checkout-btn">Checkout &#x2192;</a>';
  html+='<button class="cart-continue cart-continue-btn">Continue Shopping</button>';
  html+='</div>';

  body.innerHTML=html;
  // Restore saved instructions
  var instrRestore=document.getElementById('cart-instr');
  if(instrRestore && savedInstr) instrRestore.value=savedInstr;
  // Save instructions on input
  if(instrRestore) instrRestore.addEventListener('input',function(){ try{ localStorage.setItem('kg_instr',instrRestore.value); }catch(e){} });
  var cont=document.querySelector('.cart-continue-btn');
  // Wire checkout button to build URL dynamically at click time (captures textarea value)
  var checkoutBtn=document.getElementById('cart-checkout-btn');
  if(checkoutBtn){
    checkoutBtn.addEventListener('click',function(e){
      e.preventDefault();
      var instrEl=document.getElementById('cart-instr');
      var instrText=instrEl?instrEl.value.trim():'';
      // Use Shopify Ajax Cart API to add each item with line item properties
      // This is the only way to get properties to show on the checkout page
      // Step 1: Clear existing Shopify cart
      fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
        .then(function(){
          // Step 2: Add items one by one to preserve properties per line item
          var items = cart.map(function(i){
            var props = Object.assign({},i.opts);
            if(instrText) props['Special Instructions'] = instrText;
            // Remove empty props
            Object.keys(props).forEach(function(k){ if(!props[k]) delete props[k]; });
            return {id: Number(i.variant_id), quantity: i.qty, properties: props};
          });
          return fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:items})
          });
        })
        .then(function(r){
          if(!r.ok) throw new Error('cart/add failed: '+r.status);
          return r.json();
        })
        .then(function(data){
          if(data.items && data.items.length > 0){
            window.location.href='/checkout';
          } else {
            throw new Error('No items added');
          }
        })
        .catch(function(err){
          console.warn('Cart API failed, permalink fallback:',err);
          var cartItemsNow=cart.map(function(i){return i.variant_id+':'+i.qty;}).join(',');
          var notesNow=cart.map(function(i){
            var o=Object.entries(i.opts).filter(function(e){return e[1];}).map(function(e){return e[0]+': '+e[1];}).join(', ');
            return i.name+(o?' ('+o+')':'');
          }).join('; ');
          var fullNotes=(notesNow&&instrText)?notesNow+' | Instructions: '+instrText:(instrText?'Instructions: '+instrText:notesNow);
          window.location.href='https://kggraphics.us/cart/'+cartItemsNow+(fullNotes?'?note='+encodeURIComponent(fullNotes):'');
        });
    });
  }
  if(cont) cont.addEventListener('click',function(){ goHome(null); setTimeout(function(){ var el=document.getElementById('products'); if(el) el.scrollIntoView({behavior:'smooth'}); },400); });
}


window.changeQty=function(idx,delta){
  cart[idx].qty+=delta;
  if(cart[idx].qty<=0) cart.splice(idx,1);
  saveCart(); updateCartBadge(); renderCart();
};
window.removeItem=function(idx){
  cart.splice(idx,1);
  saveCart(); updateCartBadge(); renderCart();
};

// ── GO PAGE ──
function goPage(name){
  closeM();
  hideAll();
  if(name==='contact'){ PCON.style.display='block'; document.title='Contact - KG Graphics'; injectFooter(PCON); }
  else if(name==='privacy'){ PPRIV.style.display='block'; document.title='Privacy Policy - KG Graphics'; injectFooter(PPRIV); }
  window.scrollTo({top:0,behavior:'instant'});
}
window.goPage=goPage;

// ── WIRE UP STATIC BUTTONS ──
document.getElementById('btn-logo').addEventListener('click',function(){ goHome(null); });
document.getElementById('nav-cart-btn').addEventListener('click',goCart);

document.querySelectorAll('[data-nav]').forEach(function(el){
  el.addEventListener('click',function(){ goHome(el.dataset.nav); });
});
document.querySelectorAll('[data-product]').forEach(function(el){
  el.addEventListener('click',function(){ goProduct(el.dataset.product,'home'); });
});
document.querySelectorAll('[data-coll]').forEach(function(el){
  el.addEventListener('click',function(){ goCollection(el.dataset.coll); });
});
// Footer home buttons (class-based, no duplicate IDs)
document.querySelectorAll('.footer-home-btn').forEach(function(btn){
  btn.addEventListener('click',function(){ goHome(null); });
});

// ── SCROLL REVEAL ──
function startReveal(){
  var all=document.querySelectorAll('.rv,.rl,.rr');
  all.forEach(function(el){el.classList.remove('in');});
  if(!('IntersectionObserver' in window)){ all.forEach(function(el){el.classList.add('in');}); return; }
  requestAnimationFrame(function(){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);} });
    },{threshold:0.05});
    all.forEach(function(el){io.observe(el);});
  });
}
startReveal();

// ── COUNT-UP ──
var ce=document.querySelector('[data-count]');
if(ce&&'IntersectionObserver' in window){
  var cio=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      var t=+e.target.dataset.count,c=0;
      var tmr=setInterval(function(){ c=Math.min(c+t/55,t); e.target.textContent=Math.round(c)+'%'; if(c>=t)clearInterval(tmr); },18);
      cio.unobserve(e.target);
    });
  },{threshold:0.5});
  cio.observe(ce);
}

// ── FAQ ──

function wireFAQ(container){
  (container||document).querySelectorAll('.faq-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.parentElement,was=item.classList.contains('op');
      var wrap=item.closest('.faq-wrap');
      if(wrap) wrap.querySelectorAll('.faq-item.op').forEach(function(i){
        i.classList.remove('op');
        i.querySelector('.faq-btn').setAttribute('aria-expanded','false');
      });
      if(!was){ item.classList.add('op'); btn.setAttribute('aria-expanded','true'); }
    });
  });
}

wireFAQ(document);

// ── EMAIL FORMS ──
window.doEmail=function(e){
  e.preventDefault();
  var inp=e.target.querySelector('.eml-input'),btn=e.target.querySelector('button');
  if(!inp||!inp.value||!inp.validity.valid){ if(inp) inp.style.borderColor='#e84040'; setTimeout(function(){if(inp)inp.style.borderColor='';},1600); return; }
  btn.textContent='Thanks!'; btn.style.background='#16a34a'; inp.value='';
  setTimeout(function(){ btn.textContent='Subscribe'; btn.style.background=''; },3200);
};

// ── HOW IT WORKS INTERACTIVE ──
document.querySelectorAll('.hiw-card').forEach(function(card){
  function toggle(){
    var open=card.classList.contains('open');
    document.querySelectorAll('.hiw-card.open').forEach(function(c){ c.classList.remove('open'); c.setAttribute('aria-expanded','false'); });
    if(!open){ card.classList.add('open'); card.setAttribute('aria-expanded','true'); }
  }
  card.addEventListener('click',toggle);
  card.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();} });
});

// ── TILT (desktop) ──
if(window.matchMedia('(pointer:fine) and (hover:hover)').matches){
  document.querySelectorAll('.pc').forEach(function(card){
    card.addEventListener('mousemove',function(e){ var r=card.getBoundingClientRect(); card.style.transform='translateY(-3px) rotateX('+(-((e.clientY-r.top)/r.height-.5)*3)+'deg) rotateY('+(((e.clientX-r.left)/r.width-.5)*3)+'deg)'; card.style.perspective='900px'; card.style.transition='transform 0.04s'; });
    card.addEventListener('mouseleave',function(){ card.style.transform=''; card.style.transition='background .2s,transform .4s'; });
  });
}


// ── CONTACT FORM ──
document.addEventListener('click', function(e){
  if(e.target && e.target.id==='cf-send'){
    var name = (document.getElementById('cf-name')||{}).value||'';
    var email = (document.getElementById('cf-email')||{}).value||'';
    var subject = (document.getElementById('cf-subject')||{}).value||'';
    var message = (document.getElementById('cf-message')||{}).value||'';
    if(!name||!email||!message){ alert('Please fill in your name, email, and message.'); return; }
    if(!/\S+@\S+\.\S+/.test(email)){ alert('Please enter a valid email address.'); return; }
    var btn = document.getElementById('cf-send');
    btn.textContent='Sending...'; btn.disabled=true;
    // Send via FormSubmit.co — free email forwarding service
    fetch('https://formsubmit.co/ajax/sales@kggraphics.us', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({name:name, email:email, subject:subject||'Website Contact', message:message, _captcha:'false'})
    }).then(function(r){ return r.json(); }).then(function(data){
      document.getElementById('cf-ok').style.display='block';
      btn.textContent='Sent!';
      document.getElementById('cf-name').value='';
      document.getElementById('cf-email').value='';
      document.getElementById('cf-subject').value='';
      document.getElementById('cf-message').value='';
    }).catch(function(){
      // Fallback: open mailto
      window.location.href='mailto:sales@kggraphics.us?subject='+encodeURIComponent(subject||'Website Contact')+'&body='+encodeURIComponent('From: '+name+' ('+email+')\n\n'+message);
      btn.textContent='Send Message'; btn.disabled=false;
    });
  }
});


// ── IMAGE PROTECTION ──
document.addEventListener('contextmenu', function(e){
  if(e.target.tagName === 'IMG'){ e.preventDefault(); return false; }
});
document.addEventListener('dragstart', function(e){
  if(e.target.tagName === 'IMG'){ e.preventDefault(); return false; }
});


// ── MOBILE IMAGE SWIPER ──
function initMobileSwiper(){
  if(window.innerWidth >= 768) return;
  var grid = document.querySelector('.pd-grid');
  if(!grid) return;
  var imgs = Array.from(grid.querySelectorAll('img'));
  if(imgs.length < 2) return;

  // Remove existing dots/btns if re-initializing
  var old = grid.parentNode.querySelectorAll('.pd-dots,.pd-swipe-btns');
  old.forEach(function(el){ el.remove(); });

  var current = 0;
  imgs.forEach(function(img, i){ img.classList.toggle('active', i===0); });

  // Dots
  var dots = document.createElement('div');
  dots.className = 'pd-dots';
  imgs.forEach(function(_,i){
    var d = document.createElement('button');
    d.className = 'pd-dot' + (i===0?' on':'');
    d.addEventListener('click', function(){ go(i); });
    dots.appendChild(d);
  });

  // Prev/Next buttons
  var btns = document.createElement('div');
  btns.className = 'pd-swipe-btns';
  var prev = document.createElement('button');
  prev.className = 'pd-swipe-btn';
  prev.innerHTML = '&#x2039;';
  var next = document.createElement('button');
  next.className = 'pd-swipe-btn';
  next.innerHTML = '&#x203a;';

  function go(n){
    imgs[current].classList.remove('active');
    dots.children[current].classList.remove('on');
    current = (n + imgs.length) % imgs.length;
    imgs[current].classList.add('active');
    dots.children[current].classList.add('on');
  }
  prev.addEventListener('click', function(){ go(current-1); });
  next.addEventListener('click', function(){ go(current+1); });
  btns.appendChild(prev);
  btns.appendChild(next);

  // Touch swipe
  var startX = 0;
  grid.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
  grid.addEventListener('touchend', function(e){
    var diff = startX - e.changedTouches[0].clientX;
    if(Math.abs(diff) > 40) go(diff > 0 ? current+1 : current-1);
  }, {passive:true});

  grid.appendChild(btns);
  grid.parentNode.insertBefore(dots, grid.nextSibling);
}
window.initMobileSwiper = initMobileSwiper;


// ── MOBILE LONG-PRESS IMAGE PROTECTION ──
document.addEventListener('touchstart', function(e){
  if(e.target.tagName === 'IMG'){ e.preventDefault(); }
}, {passive:false});


// ── SHARED FOOTER INJECTION ──
function injectFooter(pageEl){
  var old = pageEl.querySelector('.page-footer-inject');
  if(old) old.remove();
  // Clone shared sections (email, connect, faq) + footer
  var wrapper = document.createElement('div');
  wrapper.className = 'page-footer-inject';
  var sharedStart = document.querySelector('.email-sec');
  var mainFooter = document.querySelector('footer');
  if(!sharedStart || !mainFooter) return;
  // Clone email, connect, faq sections
  var el = sharedStart;
  while(el && el !== mainFooter){
    wrapper.appendChild(el.cloneNode(true));
    el = el.nextElementSibling;
  }
  // Clone footer
  var clone = mainFooter.cloneNode(true);
  clone.querySelectorAll('[data-coll]').forEach(function(btn){
    btn.addEventListener('click',function(){ goCollection(btn.dataset.coll); });
  });
  clone.querySelectorAll('[data-product]').forEach(function(btn){
    btn.addEventListener('click',function(){ goProduct(btn.dataset.product,'footer'); });
  });
  clone.querySelectorAll('.footer-home-btn').forEach(function(btn){
    btn.addEventListener('click',function(){ goHome(); });
  });
  clone.querySelectorAll('button[onclick]').forEach(function(btn){
    var fn=btn.getAttribute('onclick');
    btn.removeAttribute('onclick');
    btn.addEventListener('click',function(){ eval(fn); });
  });
  wrapper.appendChild(clone);
  // Force cloned rv elements visible (they won't animate in)
  wrapper.querySelectorAll('.rv').forEach(function(el){
    el.style.opacity='1';
    el.style.transform='none';
    el.classList.remove('rv');
  });
  wireFAQ(wrapper);
  pageEl.appendChild(wrapper);
}


// ── NAV SCROLL TINT ──
(function(){
  var nav=document.querySelector('.nav');
  if(!nav) return;
  function onScroll(){ nav.classList.toggle('scrolled', window.scrollY > 10); }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();

})();